const T = {
  'zh-TW': {
    // === NAVIGATION ===
    navDashboard: '總覽',
    navMore: '更多',
    navPositions: '職位管理',
    navUsers: '員工管理',
    navNotify: '發送通知',
    navLogs: '操作日誌',
    navRegister: '批次建立帳號',
    locked: '未開通',
    lockedMsg: '貴公司尚未開通此模組',
    lockedContact: '立即聯絡 YPFOPS 客服',
    backToHome: '← 返回總覽',
    logout: '登出',

    // === SETTINGS TABS ===
    settings: '個人設定',
    profile: '基本資料',
    password: '修改密碼',
    appearance: '介面設定',
    dashboard: '儀表板',

    // === THEME ===
    themeLabel: '顯示主題',
    light: '淺色模式',
    dark: '深色模式',

    // === LANGUAGE ===
    languageLabel: '介面語言',
    langZh: '繁體中文',
    langEn: 'English',
    langVi: 'Tiếng Việt',

    // === PROFILE ===
    employeeId: '工號',
    department: '部門',
    position: '職位',
    loginAccount: '登入帳號',
    adminNote: '以上資料由管理員管理，如需更改請聯繫公司管理員',
    displayName: '顯示名稱',
    namePlaceholder: '輸入您的姓名',
    phone: '手機 / 聯絡電話',
    phonePlaceholder: '例：0912-345-678',
    saveProfile: '✓ 儲存資料',
    saving: '儲存中...',

    // === PASSWORD ===
    pwdReminder: '密碼更改後，下次登入請使用新密碼。建議使用英數字混合、至少 8 個字元以上。',
    newPassword: '新密碼',
    newPasswordPlaceholder: '至少 6 個字元',
    confirmPassword: '確認新密碼',
    confirmPasswordPlaceholder: '再次輸入新密碼',
    pwdMismatch: '⚠ 兩次密碼不一致',
    pwdCheck8: '✓ 8碼以上',
    pwdCheckFail8: '✗ 未達8碼',
    pwdCheckMixed: '✓ 英數混合',
    pwdCheckFailMixed: '✗ 建議英數混合',
    changePassword: '🔐 更新密碼',
    changingPassword: '更新中...',
    profileSaved: '✓ 個人資料已更新',
    pwdSaved: '✓ 密碼已更新，請以新密碼重新登入時使用',
    fieldRequired: '姓名不能為空',
    pwdRequired: '請輸入新密碼',
    pwdTooShort: '密碼至少需要 6 個字元',

    // === COMMON UI ===
    loading: '載入中...',
    noData: '尚無資料',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    editBtn: '✏️ 編輯',
    deleteBtn: '刪除',
    addBtn: '新增',
    searchBtn: '搜尋',
    exportBtn: '📤 匯出',
    importBtn: '📥 匯入',
    actions: '操作',
    statusLabel: '狀態',
    noteLabel: '備注',
    dateLabel: '日期',
    nameLabel: '名稱',
    phoneLabel: '電話',
    addressLabel: '地址',
    totalLabel: '總計',
    prevPage: '‹ 上一頁',
    nextPage: '下一頁 ›',
    selectAll: '全選',
    deselectAll: '取消全選',
    selectAllPage: '全選本頁',
    clearFilter: '✕ 清除篩選',
    noMatchResult: '沒有符合條件的結果',
    processingBtn: '處理中...',
    savingBtn: '儲存中...',
    updatingBtn: '更新中...',
    creatingBtn: '建立中...',
    submittingBtn: '送出中...',
    allStatuses: '全部狀態',
    filterAll: '全部',
    confirmUpdate: '確認更新',
    confirmAdd: '確認新增',

    // === APP / DASHBOARD ===
    notifPanelTitle: '通知',
    markAllReadBtn: '全部已讀',
    noNotifications: '暫無通知',
    systemSourceBadge: '系統通知',
    systemShortLabel: '系統',
    dashboardTitle: '總覽儀表板',
    welcomeBackLabel: '歡迎回來，',
    dashProductTypes: '商品種類',
    dashTotalStock: '總庫存量',
    dashStockAlert: '庫存警示',
    dashTransactionRecords: '異動紀錄',
    dashStockAlertBanner: '庫存警示 — 以下商品需補貨',
    dashSystemModules: '系統模組',
    moduleNotEnabled: '未開啟',
    dashRecentTransactions: '最近交易紀錄',
    dashNoTransactions: '尚無交易紀錄',
    realtimeSynced: '即時同步',
    connectingStatus: '連線中...',
    companyAdminRole: '公司管理員',
    managerRole: '主管',
    generalUserRole: '一般用戶',
    needsUpgradeLocked: '需升級方案',
    logoutBtn: '登出',
    featureModulesHeading: '功能模組',
    fullBackupBtn: '全局備份',
    backupBtnDesc: '下載所有資料到本機',
    backupInProgress: '備份中...',
    backupComplete: '備份完成，已下載到本機',
    insufficientPermissions: '權限不足',
    noAccessMessage: '您的帳號沒有存取此功能的權限',
    backToOverviewBtn: '返回總覽',
    moduleNotActivated: '貴公司尚未開通此模組',
    contactSupportMsg: '立即聯絡 YPFOPS 客服',
    unlockMoreMsg: '解鎖更多強大功能！',
    sendNotifyTitle: '發送通知',
    sendNotifySubtitle: '向公司內部用戶發送即時通知',
    notifyTargetLabel: '發送對象',
    allEmployeesOption: '全體員工',
    notifyTitleLabel: '通知標題 *',
    notifyTitlePlaceholder: '例：重要公告、出勤提醒...',
    notifyBodyLabel: '通知內容 *',
    notifyBodyPlaceholder: '填寫通知詳細內容...',
    sendingNotifyBtn: '發送中...',
    sendNowBtn: '立即發送',
    logsPageTitle: '操作日誌',
    logSearchPlaceholder: '搜尋操作人、動作、詳細...',
    clearLogSearchBtn: '清除',
    reloadLogsBtn: '重新載入',
    noLogsMessage: '尚無日誌，或載入失敗',
    noMatchingLogs: '沒有符合條件的日誌',
    logColTime: '時間',
    logColOperator: '操作人',
    logColAction: '動作',
    logColDetail: '詳細',

    // === WMS ===
    warehouseTitle: '📦 倉儲管理',
    wmsSubtitle: '入出庫 · 庫存 · 商品 · 出貨 · 待入庫',
    wmsTabInOut: '入出庫',
    wmsTabBatchIn: '批次入庫',
    wmsTabLabels: '包裝標籤',
    wmsTabInventory: '庫存狀況',
    wmsTabPendingShip: '待出貨',
    wmsTabPendingIn: '待入庫',
    wmsTabRecords: '紀錄查詢',
    wmsProductTypes: '商品種類',
    wmsTotalStock: '總庫存量',
    wmsPendingShip: '待出貨',
    wmsStockMovements: '異動紀錄',
    wmsTransactionTitle: '🔄 入出庫登記',
    wmsProductField: '商品 *',
    wmsSearchProduct: '搜尋商品名稱...',
    wmsStockIn: '▲ 入庫',
    wmsStockOut: '▼ 出庫',
    wmsStockInsufficient: '⛔ 庫存不足',
    wmsBelowSafeStock: '⚠️ 此商品已低於安全庫存，需要補貨',
    wmsOutDate: '出庫日期',
    wmsNonTodayNote: '📅 已設定為非今日出庫，出貨單日期將使用此日期',
    wmsCreateShip: '🚚 同時建立出貨單',
    wmsAutoCreateShipDesc: '出庫後自動新增待出貨訂單',
    wmsCustomerName: '客戶名稱 *',
    wmsCustomerPh: '客戶名稱',
    wmsDriverLabel: '司機',
    wmsSelectDriver: '-- 選擇司機 --',
    wmsLicensePlate: '車牌號碼',
    wmsConfirmStockIn: '▲ 確認入庫',
    wmsConfirmStockOut: '▼ 確認出庫',
    wmsRecentRecords: '最近 10 筆紀錄',
    wmsBatchInTitle: '📦 批次入庫',
    wmsBatchInDesc: '一次入庫多項商品，適合採購到貨或盤點補充',
    wmsAddProductRow: '+ 新增商品',
    wmsConfirmBatchIn: '▲ 確認批次入庫',
    wmsBatchPreview: '入庫預覽',
    wmsInventoryHeading: '📊 目前庫存狀況',
    wmsSearchNameSku: '🔍 搜尋商品名稱 / SKU',
    wmsAllCategories: '全部分類',
    wmsLowStockWarning: '⚠️ 低庫存警示',
    wmsNeedsReplenishment: '⚠ 補貨',
    wmsStockNormal: '✓ 正常',
    wmsInventoryCount: '📋 盤點',
    wmsPendingShipHeading: '🚚 待出貨清單',
    wmsPrepareShipDesc: '以下出貨單尚未出貨，請準備備貨',
    wmsGoToShipping: '前往出貨管理 →',
    wmsNoShipments: '目前沒有待出貨的訂單！',
    wmsPendingInHeading: '📋 待手動入庫工單',
    wmsWaitingManualIn: '以下工單已完工，等待手動入庫',
    wmsNoPendingIn: '目前沒有待手動入庫的工單',
    wmsStockInProductLbl: '入庫商品 *',
    wmsConfirmStockInSmall: '確認入庫',
    wmsExecuteStockIn: '執行入庫',
    wmsAutoStockInHeading: '⚡ 自動入庫明細',
    wmsAutoStockInDesc: '由生產工單自動觸發的入庫紀錄',
    wmsNoAutoLogs: '尚無自動入庫紀錄',
    wmsEditRecordTitle: '✏️ 編輯紀錄',
    wmsEditReasonLabel: '修改原因 *',
    wmsCurrentStock: '目前庫存：',
    wmsAdjustedQty: '調整後庫存數量 *',
    wmsStockDiff: '差異：',
    wmsCountReason: '盤點原因 *',
    wmsConfirmAdjust: '確認盤點調整',
    wmsNoMatchRecords: '沒有符合條件的紀錄',
    wmsLowStock: '低庫存',

    // === PRODUCTS ===
    productMgmtTitle: '📦 商品管理',
    productSubtitle: '商品目錄、規格、庫存、價格管理',
    productTotal: '商品總數',
    productActive: '啟用中',
    productCategories: '商品分類',
    productStockValue: '📊 庫存總值（成本）',
    productListTab: '📦 商品清單',
    productAnalyticsTab: '📊 統計分析',
    productSearchPh: '🔍 搜尋名稱、SKU、條碼...',
    productActiveOpt: '✅ 啟用中',
    productInactiveOpt: '⏸ 已停用',
    productLowStockOpt: '⚠️ 低庫存',
    productLowStockAlert: '項商品低於安全庫存，需要補貨',
    productNameLabel: '商品名稱 *',
    productSku: 'SKU 編號 *',
    productCategoryLabel: '分類',
    productUnit: '單位',
    productInitialStock: '初始庫存',
    productSafeStock: '安全庫存',
    productCostPrice: '成本價 (NT$)',
    productSellPrice: '售價 (NT$)',
    productBarcode: '條碼',
    productSpec: '規格',
    productSpecPh: '尺寸、顏色、材質...',
    productMinOrder: '最小訂購量',
    productWeight: '重量 (kg)',
    productLeadTime: '前置時間（天）',
    productImageUrl: '圖片網址',
    productSelectCategory: '-- 選擇分類 --',
    productAddCategory: '+ 新增',
    productNewCategoryHint: '輸入新分類名稱',
    productNamePh: '輸入商品名稱',
    productConfirmAdd: '確認新增',
    productConfirmUpdate: '確認更新',
    productQrLabels: '🏷️ QR 標籤',
    productImportTitle: '📥 批量匯入商品',
    productDownloadTemplate: '⬇ 下載範本',
    productSelectFile: '📂 選擇檔案',
    productConfirmImport: '確認匯入',
    productCurrentStock: '現有庫存',
    productGrossMargin: '毛利',
    productDeactivate: '停用',
    productActivate: '啟用',
    productDetail: '詳情',
    productQuickAdjust: '快速調整庫存',
    productStockInTitle: '▲ 快速入庫',
    productStockOutTitle: '▼ 快速出庫',
    productDetailTitle: '📦 商品詳情',
    productActiveStatus: '✅ 啟用',
    productInactiveStatus: '⏸ 停用',
    productNewProduct: '+ 新增商品',
    productNoData: '尚無商品資料',

    // === TASKS ===
    taskPageTitle: '📋 任務管理',
    taskPageSubtitle: '指派任務・追蹤進度・團隊協作',
    taskTabMy: '我的任務',
    taskTabManage: '指派管理',
    taskTabAnalytics: '任務統計',
    taskCatGeneral: '一般任務',
    taskCatSafety: '安全衛生',
    taskCatQuality: '品質管理',
    taskCatTraining: '教育訓練',
    taskCatMaintenance: '設備保養',
    taskCatImprovement: '改善提案',
    taskPriUrgent: '緊急',
    taskPriHigh: '重要',
    taskPriNormal: '一般',
    taskPriLow: '低',
    taskStatusPending: '未開始',
    taskStatusInProgress: '進行中',
    taskStatusHelp: '需要協助',
    taskStatusCompleted: '已完成',
    taskNameLabel: '任務名稱 *',
    taskNamePh: '輸入任務名稱',
    taskDescLabel: '任務說明（選填）',
    taskCategoryLabel: '分類',
    taskPriorityLabel: '優先程度',
    taskDueDateLabel: '截止日期（選填）',
    taskAssignLabel: '指派對象 *',
    taskSearchEmployee: '🔍 搜尋員工姓名',
    taskNoTasks: '目前沒有指派給您的任務',
    taskRelax: '好好休息一下吧！',
    taskMyProgress: '我的任務進度',
    taskGroupOverdue: '🔴 已逾期',
    taskGroupUrgent: '⚡ 緊急 / 即將到期',
    taskGroupInProgress: '⚙️ 進行中',
    taskGroupNotStarted: '📋 未開始',
    taskGroupDone: '✅ 已完成',
    taskAllDone: '所有任務都完成了！',
    taskBtnStart: '⚡ 開始任務',
    taskBtnComplete: '✅ 完成任務',
    taskBtnConfirmComplete: '✅ 確認完成',
    taskBtnAskHelp: '🆘 求助',
    taskBtnResume: '⚡ 繼續任務',
    taskBtnDetail: '明細',
    taskBtnRemind: '🔔 提醒',
    taskBtnEdit: '✏️ 編輯',
    taskBtnArchive: '📦 封存',
    taskBtnRestore: '↩ 還原',
    taskBtnDelete: '🗑 刪除',
    taskNewTask: '+ 新增任務',
    taskFormNew: '📋 新增任務',
    taskFormEdit: '✏️ 編輯任務',
    taskConfirmCreate: '確認建立',
    taskConfirmUpdate: '確認更新',
    taskHelpTitle: '🆘 請求協助',
    taskHelpDesc: '說明需要的協助，主管會盡快聯繫您',
    taskHelpProblem: '說明問題 *',
    taskHelpPh: '例：不知道如何操作機台、材料不足、需要額外人手...',
    taskSubmitHelp: '🆘 送出協助請求',
    taskEmptyArchived: '沒有已封存的任務',
    taskEmptyNoTask: '尚無任務',

    // === CRM ===
    crmPageTitle: '👥 客戶管理',
    crmPageSubtitle: '客戶資料 · 聯絡資訊 · 出貨紀錄',
    crmTotalCustomers: '客戶總數',
    crmHasPhone: '有電話',
    crmHasEmail: '有 Email',
    crmNewThisMonth: '本月新增',
    crmSearchPh: '🔍 搜尋名稱、統編、聯絡人、電話、Email...',
    crmViewTable: '☰ 表格',
    crmViewCard: '⊞ 卡片',
    crmNewCustomer: '+ 新增客戶',
    crmFormNewTitle: '👥 新增客戶',
    crmCustName: '客戶名稱 *',
    crmTaxId: '統一編號',
    crmContact: '聯絡人',
    crmAddress: '地址',
    crmNote: '備注',
    crmCustNamePh: '公司或個人名稱',
    crmTaxIdPh: '8碼統編',
    crmContactPh: '負責人/窗口',
    crmAddressPh: '縣市 + 詳細地址',
    crmNotePh: '補充說明、特殊需求...',
    crmConfirmAdd: '確認新增',
    crmThName: '客戶名稱',
    crmThTaxId: '統編',
    crmThContact: '聯絡人',
    crmThCreated: '建立日期',
    crmThAction: '操作',
    crmNoCustomers: '尚無客戶資料',
    crmNoMatch: '沒有符合的客戶',
    crmEditTitle: '✏️ 編輯客戶',
    crmConfirmUpdate: '✓ 確認更新',
    crmProfileCompanyName: '公司名稱',
    crmProfileContact: '聯絡人',
    crmProfilePhone: '電話',
    crmProfileAddress: '地址',
    crmShipHistory: '出貨紀錄',
    crmNoShipHistory: '尚無出貨紀錄',
    crmShipPending: '待處理',
    crmShipConfirmed: '已確認',
    crmShipShipped: '已出貨',
    crmShipCancelled: '已取消',

    // === PURCHASING ===
    purPageTitle: '🛒 採購管理',
    purPageSubtitle: '供應商管理 · 採購申請 · 進貨追蹤',
    purTabPO: '採購申請單',
    purTabSuppliers: '供應商管理',
    purTabAnalytics: '採購統計',
    purKpiSuppliers: '合作供應商',
    purKpiTotalPO: '採購單總數',
    purKpiPending: '待審核',
    purKpiOrdered: '已下單待收',
    purKpiReceived: '本月已收貨',
    purKpiOverdue: '逾期未收',
    purStatusDraft: '草稿',
    purStatusPending: '待審核',
    purStatusApproved: '已核准',
    purStatusOrdered: '已下單',
    purStatusReceived: '已收貨',
    purStatusCancelled: '已取消',
    purPoNoLabel: '採購單號 *',
    purPoNoPh: '自動產生',
    purSupplierLabel: '供應商 *',
    purSearchSupplier: '搜尋供應商...',
    purRequester: '申請人',
    purExpectedDate: '預計到貨日',
    purNoteLabel: '備注（選填）',
    purNotePh: '採購原因、特殊要求...',
    purItems: '採購品項',
    purItemName: '品名 / 說明',
    purItemNamePh: '例：辦公桌椅、電腦設備、清潔用品...',
    purQty: '數量',
    purUnit: '單位',
    purUnitPrice: '單價 (NT$)',
    purAddItem: '+ 新增品項',
    purTotalAmount: '總金額 Total：NT$',
    purNewPO: '+ 新增採購單',
    purFormNew: '🛒 新增採購申請單',
    purFormEdit: '✏️ 編輯採購單',
    purConfirmCreate: '確認建立採購單',
    purSearchPO: '🔍 搜尋單號、供應商...',
    purNoPO: '尚無採購單',
    purBtnDetail: '🔍 詳情',
    purBtnSubmit: '📤 送審',
    purBtnApprove: '✅ 核准',
    purBtnOrdered: '📦 已下單',
    purBtnReceived: '🎉 確認收貨',
    purBtnCancel: '✕ 取消',
    purSupplierActive: '合作中',
    purSupplierInactive: '停用',
    purNewSupplier: '+ 新增供應商',
    purFormNewSupplier: '🏭 新增供應商',
    purFormEditSupplier: '✏️ 編輯供應商',
    purSupplierName: '供應商名稱 *',
    purSupplierCode: '供應商代號',
    purPaymentTerms: '付款條件',
    purSupplierAddress: '地址',
    purNoSuppliers: '尚無供應商',
    purDetailTitle: '📋 採購單詳情',
    purCancelTitle: '取消採購單',
    purCancelReason: '取消原因（選填）',
    purConfirmCancel: '確認取消此採購單',

    // === PRODUCTION ===
    prodPageTitle: '🏭 生產管理',
    prodSubtitle: '工單追蹤',
    prodTabWorkOrders: '📋 工單管理',
    prodTabMachines: '⚙️ 機台管理',
    prodNewOrder: '+ 新增工單',
    prodStageSettings: '⚙️ 階段設定',
    prodSearchOrders: '🔍 搜尋工單號、產品名稱...',
    prodFilterOverdue: '⚠️ 逾期',
    prodNoMatch: '沒有符合的工單',
    prodNoOrders: '尚無工單',
    prodOrderNo: '工單號 *',
    prodLinkedProduct: '關聯產品（可選）',
    prodSearchProduct: '搜尋產品...',
    prodOrderName: '產品 / 工單名稱 *',
    prodBatchQty: '批次數量 *',
    prodStartDate: '開始日期',
    prodDueDate: '預計完成',
    prodMachine: '負責機台',
    prodSearchMachine: '搜尋機台代號/名稱...',
    prodDepartment: '負責部門',
    prodDepartmentPh: '例：A線、沖壓部...',
    prodNoteLabel: '備注',
    prodConfirmCreate: '確認建立工單',
    prodStatusPending: '待開始',
    prodStatusInProd: '生產中',
    prodStatusDone: '完成',
    prodBadgeOverdue: '⚠️ 逾期',
    prodBadgeQcPassed: '✅ 品管通過',
    prodBadgeQcFailed: '❌ 品管未通過',
    prodBtnStart: '🚀 開始',
    prodBtnAdvance: '▶ 推進至',
    prodBtnEdit: '✏️ 編輯',
    prodBtnHistory: '📋 紀錄',
    prodBtnWarehouse: '📦 前往入庫',
    prodBtnDelete: '刪除',
    prodReportProgress: '📝 回報進度',
    prodMoveToLabel: '推進到',
    prodCompletionInfo: '✅ 完工資訊',
    prodActualQty: '實際完成數量 *',
    prodStockMode: '入庫方式',
    prodAutoStock: '⚡ 自動入庫',
    prodManualStock: '📋 手動入庫',
    prodReporter: '回報人員',
    prodQcRecord: '🔍 品管記錄（選填）',
    prodQcName: '品管人員',
    prodQcResult: '品管結果',
    prodQcPass: '✅ 通過',
    prodQcFail: '❌ 不通過',
    prodQcPending: '— 未審',
    prodQcNote: '品管備注',
    prodConfirmAdvance: '確認推進至：',
    prodHistoryTitle: '📋 生產紀錄',
    prodNoHistory: '尚無進度紀錄',
    prodEditTitle: '✏️ 編輯工單',
    prodSaveChanges: '✓ 儲存變更',
    prodStageSettingsTitle: '⚙️ 生產階段設定',
    prodAddStage: '新增',
    prodSaveSettings: '✓ 儲存設定',
    prodResetDefault: '恢復預設',
    prodMachineCountInfo: '資料與維修模組共用',
    prodAddMachine: '+ 新增機台',
    prodAddMachineTitle: '⚙️ 新增機台',
    prodNoMachines: '尚無機台資料',
    prodMachineStatusNormal: '正常',
    prodMachineStatusMaint: '維修中',
    prodMachineStatusInactive: '停用',
    prodMachineName: '機台名稱 *',
    prodMachineCode: '機台代號 *',
    prodMachineDiv: '所屬部門',
    prodMachineLocation: '位置',
    prodMachineResponsible: '負責人',
    prodMachineSupplier: '供應廠商',
    prodMachineStatusLabel: '狀態',
    prodEditMachineTitle: '✏️ 編輯機台',

    // === SHIPPING ===
    shipPageTitle: '🚚 出貨管理',
    shipSubtitle: '出貨單、司機車牌管理',
    shipTabShipments: '📋 出貨單',
    shipTabRecords: '🔍 紀錄查詢',
    shipTabDrivers: '🚛 司機 / 車牌管理',
    shipStatTotal: '出貨單總數',
    shipStatPending: '待出貨',
    shipStatShipped: '已出貨',
    shipStatDrivers: '可用司機',
    shipStatusPending: '待出貨',
    shipStatusShipped: '已出貨',
    shipStatusCancelled: '已取消',
    shipNewShipment: '+ 新增出貨單',
    shipSearchPh: '🔍 搜尋客戶名稱 / 出貨單號',
    shipNoLabel: '出貨單號 *',
    shipCustomerLabel: '客戶名稱 *',
    shipSearchCustomer: '搜尋客戶名稱...',
    shipDateLabel: '出貨日期',
    shipDriverSection: '🚛 司機 / 車牌資訊',
    shipSelectDriver: '選擇司機',
    shipDriverNameLabel: '司機姓名',
    shipLicensePlate: '車牌號碼',
    shipItemsSection: '出貨品項',
    shipProductLabel: '商品',
    shipQtyLabel: '數量',
    shipFormTitle: '🚚 新增出貨單',
    shipConfirmCreate: '確認建立出貨單',
    shipThNo: '出貨單號',
    shipThCustomer: '客戶',
    shipThDriver: '司機',
    shipThPlate: '車牌',
    shipThItems: '品項',
    shipThDate: '出貨日期',
    shipThStatus: '狀態',
    shipThAction: '操作',
    shipNoShipments: '尚無出貨單',
    shipBtnDetail: '詳情',
    shipBtnConfirmShip: '確認出貨',
    shipBtnCancel: '取消',
    shipAddDriver: '+ 新增司機',
    shipAddDriverTitle: '🚛 新增司機',
    shipNoDrivers: '尚無司機資料',
    shipDriverStatus: '狀態',
    shipDriverEmployed: '✅ 在職',
    shipDriverResigned: '⏸ 離職',
    shipConfirmAddDriver: '確認新增',
    shipEditDriverTitle: '✏️ 編輯司機',
    shipDetailTitle: '📋 出貨單詳情',
    shipNoRecords: '沒有符合條件的紀錄',

    // === MAINTENANCE ===
    mntPageTitle: '🔧 機械維修',
    mntSubtitle: '故障報修 · 保養 · 備品更換 · 機台管理',
    mntTabRecords: '🔧 維修紀錄',
    mntTabMachines: '⚙️ 機台管理',
    mntTypeBreakdown: '故障維修',
    mntTypePreventive: '預防保養',
    mntTypeScheduled: '定期保養',
    mntTypeInspection: '例行巡檢',
    mntTypeParts: '更換備品',
    mntStatusPending: '待處理',
    mntStatusInProgress: '維修中',
    mntStatusWaitParts: '等待零件',
    mntStatusCompleted: '已完成',
    mntKpiStopped: '停機中',
    mntKpiWaitParts: '等零件',
    mntKpiTotal: '機台總數',
    mntFilterActive: '⚡ 進行中',
    mntFilterAll: '全部',
    mntFilterWaitParts: '📦 等零件',
    mntFilterCompleted: '✅ 已完成',
    mntNewReport: '+ 新增報修',
    mntSearchPh: '🔍 搜尋機台、通報人、問題描述...',
    mntNoMatch: '沒有符合的維修紀錄',
    mntNoActive: '目前沒有待處理的維修事項 ✅',
    mntNoRecords: '尚無維修紀錄',
    mntReportTitle: '🔧 新增維修通報',
    mntSelectMachine: '⚙️ 選擇機台 *',
    mntSearchMachine: '輸入機台代號或名稱搜尋...',
    mntReportType: '通報類型 *',
    mntMachineDown: '🔴 機台已停機',
    mntProblemDesc: '問題描述 *',
    mntProblemPh: '詳細描述故障情況、異常現象...',
    mntReporterName: '通報人 *',
    mntSubmitReport: '📤 送出通報',
    mntAssignTitle: '⚙️ 指派維修',
    mntAssignee: '維修負責人 *',
    mntEstDone: '預計完成日期',
    mntConfirmAssign: '▶ 確認指派，開始維修',
    mntWaitPartsTitle: '📦 等待零件',
    mntNeededParts: '需要哪些零件 / 備品？',
    mntNeededPartsPh: '例：軸承 × 2、油封 × 1、皮帶 × 3...',
    mntConfirmWaitParts: '📦 確認，等待零件到貨',
    mntCompleteTitle: '✅ 回報完工',
    mntSolution: '維修方式 / 解決方案 *',
    mntSolutionPh: '填寫如何排除故障、解決步驟...',
    mntPartsUsed: '🔩 使用備品 / 更換零件',
    mntRepairCost: '維修費用 NT$',
    mntConfirmComplete: '✅ 確認完工',
    mntDetailTitle: '🔧 維修詳情',
    mntMachineCode: '機台代號',
    mntReportDate: '通報日期',
    mntNoMachines: '尚無機台資料，請點右上角新增',
    mntBtnAssign: '⚙️ 指派並開始',
    mntBtnWaitParts: '📦 等待零件',
    mntBtnComplete: '✅ 回報完成',
    mntBtnDetail: '👁 詳情',
    mntBtnModify: '✏️ 修改',

    // === FIVES ===
    fivesPageTitle: '5S 管理系統',
    fivesSubtitle: '整理 · 整頓 · 清掃 · 清潔 · 素養',
    fivesTabMyScore: '我的評分',
    fivesTabHistory: '歷史紀錄',
    fivesTabManage: '管理表單',
    fivesTabAnalytics: '統計分析',
    fivesScoreUnacceptable: '不合格',
    fivesScorePoor: '待改善',
    fivesScoreAverage: '普通',
    fivesScoreGood: '良好',
    fivesScoreExcellent: '優秀',
    fivesDimSeiri: '整理',
    fivesDimSeiton: '整頓',
    fivesDimSeiso: '清掃',
    fivesDimSeiketsu: '清潔',
    fivesDimShitsuke: '素養',
    fivesNoFormThisWeek: '本週尚無指派給您的 5S 表單',
    fivesContactAdmin: '請聯繫管理員建立並指派表單',
    fivesViewHistory: '查看歷史紀錄',
    fivesAlreadySubmitted: '已提交',
    fivesLowScoreAlert: '低分項目需注意',
    fivesNotScored: '未評分',
    fivesSubmitWeekly: '提交本週 5S 評分',
    fivesUpdateScore: '更新評分',
    fivesNoHistory: '您尚無 5S 歷史紀錄',
    fivesCreateForm: '建立新表單',
    fivesCopyLast: '複製上週表單',
    fivesExportAll: '匯出全部記錄',
    fivesFormTitle: '表單名稱 *',
    fivesWeekStart: '週起始日 *',
    fivesAssignUsers: '指派填寫人員 *',
    fivesNoForms: '尚無 5S 表單',
    fivesFormActive: '進行中',
    fivesFormInactive: '已停用',
    fivesDeactivate: '停用',
    fivesActivate: '啟用',
    fivesDelete: '刪除',
    fivesDetailTitle: '詳情',
    fivesNoDataAnalytics: '尚無足夠資料進行統計分析',
    fivesThisWeekAvg: '本週平均分',
    fivesThisWeekRate: '本週提交率',
    fivesTopEmployee: '最佳員工',
    fivesNeedsImprovement: '最需改善項',
    fivesWeeklyTrend: '歷週平均分趨勢',
    fivesMonthlySubmit: '每月提交次數',
    fivesDimAvg: '各維度平均分',
    fivesEmployeeRanking: '員工評分排行',

    // === ATTENDANCE ===
    attPageTitle: '出勤管理',
    attSubtitle: '打卡、月曆、請假、工時統計',
    attTabMyClock: '我的打卡',
    attTabCalendar: '月曆',
    attTabLeave: '請假申請',
    attTabManage: '出勤管理',
    attTabAnalytics: '統計分析',
    attStatusNormal: '正常',
    attStatusLate: '遲到',
    attStatusEarlyLeave: '早退',
    attStatusAbsent: '缺勤',
    attStatusLeave: '請假',
    attLeaveAnnual: '特休假',
    attLeaveSick: '病假',
    attLeavePersonal: '事假',
    attLeaveOfficial: '公假',
    attLeaveOther: '其他',
    attLeaveStatusPending: '待審核',
    attLeaveStatusApproved: '已核准',
    attLeaveStatusRejected: '已拒絕',
    attClockInTime: '上班時間',
    attClockOutTime: '下班時間',
    attWorkHours: '工時',
    attNotClockedIn: '今天尚未打卡',
    attClockInBtn: '上班打卡',
    attClockOutBtn: '下班打卡',
    attMonthlyAttendance: '本月出勤',
    attMonthlyHours: '本月工時',
    attMonthlyLate: '本月遲到',
    attMonthlyOvertime: '本月加班',
    attNoClockRecords: '尚無打卡紀錄',
    attCalPrevMonth: '上個月',
    attCalNextMonth: '下個月',
    attReturnThisMonth: '回本月',
    attLeaveType: '假別',
    attStartDate: '開始日期 *',
    attEndDate: '結束日期 *',
    attLeaveReason: '請假原因 *',
    attLeaveReasonPh: '請填寫請假原因...',
    attSubmitLeave: '送出請假申請',
    attMyApplications: '我的申請',
    attAllApplications: '全部申請 (管理)',
    attApprove: '核准',
    attReject: '拒絕',
    attNoLeaveRecords: '尚無請假紀錄',
    attTodayClockedIn: '今日已打卡',
    attTodayLate: '今日遲到',
    attTodayNotClockedIn: '今日未打卡',
    attExportCsv: '匯出 CSV',
    attSettings: '設定',
    attManualClock: '手動補打卡',
    attThDate: '日期',
    attThEmployee: '員工',
    attThClockIn: '上班',
    attThClockOut: '下班',
    attThHours: '工時',
    attThStatus: '狀態',
    attNoRecords: '尚無出勤紀錄',
    attWorkStart: '上班時間',
    attWorkEnd: '下班時間',
    attLateThreshold: '遲到寬限（分鐘）',
    attRequireGps: '強制 GPS 驗證',
    attConfirmSave: '確認儲存',
    attAnalyticsTotal: '本月出勤總筆',
    attAnalyticsLate: '本月遲到次數',
    attAnalyticsHours: '本月總工時',
    attAnalyticsOvertime: '本月加班工時',
    attTrend6Months: '近 6 個月出勤趨勢',
    attPersonalStats: '本月個人出勤統計',
    attNoDataThisMonth: '本月尚無資料',
    attLateRanking: '本月遲到排行',
    attExportReport: '匯出報表',

    // === REPORTS ===
    rptPageTitle: '報表分析',
    rptSubtitle: '入出庫 · 出貨 · 採購 · 生產 · 庫存 · 維修',
    rptTabOverview: '總覽',
    rptTabInOut: '入出庫趨勢',
    rptTabShipping: '出貨分析',
    rptTabPurchasing: '採購分析',
    rptTabProduction: '生產效率',
    rptTabInventory: '庫存分析',
    rptTabMaintenance: '維修報表',
    rptKpiProductTypes: '商品種類',
    rptKpiNeedsRestock: '需要補貨',
    rptKpiSufficient: '庫存充足',
    rptKpiInbound: '本月入庫',
    rptKpiOutbound: '本月出庫',
    rptKpiShipments: '本月出貨單',
    rptKpiWorkOrderRate: '工單完成率',
    rptNoData: '尚無資料',
    rptLast7DaysTitle: '近7天入出庫',
    rptLegendInbound: '入庫',
    rptLegendOutbound: '出庫',
    rptRestockAlertTitle: '補貨警示',
    rptAllSufficient: '所有商品庫存充足',
    rptWorkOrderStatus: '工單狀態',
    rptShippingTitle: '近6個月出貨單數',
    rptPurchasingTitle: '近6個月採購單數',
    rptProductionTitle: '工單完成率',
    rptInventoryByCategory: '分類庫存',
    rptRestockList: '補貨警示清單',
    rptExportRestock: '匯出補貨單',
    rptInventoryTurnover: '庫存周轉率 TOP 10',
    rptExportInventory: '匯出庫存全覽 CSV',
    rptMaintTotal: '維修紀錄總數',
    rptMaintProcessing: '處理中',
    rptMaintStopped: '停機中',
    rptMaintCost: '累計維修費',
    rptMonthlyRepair: '每月維修次數',
    rptRepairTypeDist: '維修類型分布',
    rptMachineFailRanking: '設備故障排行',
    rptRecentCompleted: '近期完成紀錄',
    rptExportAll: '匯出全部',
    rptNoCompletedRepairs: '尚無已完成維修紀錄',
  },

  en: {
    // === NAVIGATION ===
    navDashboard: 'Overview',
    navMore: 'More',
    navPositions: 'Positions',
    navUsers: 'Employees',
    navNotify: 'Notify',
    navLogs: 'Activity Logs',
    navRegister: 'Batch Register',
    locked: 'Unavailable',
    lockedMsg: 'This module is not activated for your company',
    lockedContact: 'Contact YPFOPS to unlock',
    backToHome: '← Back to Home',
    logout: 'Logout',

    // === SETTINGS TABS ===
    settings: 'Settings',
    profile: 'Profile',
    password: 'Change Password',
    appearance: 'Appearance',
    dashboard: 'Dashboard',

    // === THEME ===
    themeLabel: 'Display Theme',
    light: 'Light Mode',
    dark: 'Dark Mode',

    // === LANGUAGE ===
    languageLabel: 'Interface Language',
    langZh: '繁體中文',
    langEn: 'English',
    langVi: 'Tiếng Việt',

    // === PROFILE ===
    employeeId: 'Employee ID',
    department: 'Department',
    position: 'Position',
    loginAccount: 'Login Email',
    adminNote: 'The above information is managed by the administrator. Please contact admin to request changes.',
    displayName: 'Display Name',
    namePlaceholder: 'Enter your name',
    phone: 'Mobile / Phone',
    phonePlaceholder: 'e.g. 0912-345-678',
    saveProfile: '✓ Save Profile',
    saving: 'Saving...',

    // === PASSWORD ===
    pwdReminder: 'After changing your password, use the new password to log in next time. We recommend a mix of letters and numbers, at least 8 characters.',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'At least 6 characters',
    confirmPassword: 'Confirm New Password',
    confirmPasswordPlaceholder: 'Enter new password again',
    pwdMismatch: '⚠ Passwords do not match',
    pwdCheck8: '✓ 8+ chars',
    pwdCheckFail8: '✗ Under 8 chars',
    pwdCheckMixed: '✓ Letters & numbers',
    pwdCheckFailMixed: '✗ Recommend mix',
    changePassword: '🔐 Update Password',
    changingPassword: 'Updating...',
    profileSaved: '✓ Profile updated',
    pwdSaved: '✓ Password updated. Use the new password next time you log in.',
    fieldRequired: 'Name is required',
    pwdRequired: 'Please enter a new password',
    pwdTooShort: 'Password must be at least 6 characters',

    // === COMMON UI ===
    loading: 'Loading...',
    noData: 'No data yet',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    editBtn: '✏️ Edit',
    deleteBtn: 'Delete',
    addBtn: 'Add',
    searchBtn: 'Search',
    exportBtn: '📤 Export',
    importBtn: '📥 Import',
    actions: 'Actions',
    statusLabel: 'Status',
    noteLabel: 'Note',
    dateLabel: 'Date',
    nameLabel: 'Name',
    phoneLabel: 'Phone',
    addressLabel: 'Address',
    totalLabel: 'Total',
    prevPage: '‹ Previous',
    nextPage: 'Next ›',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selectAllPage: 'Select All on This Page',
    clearFilter: '✕ Clear Filters',
    noMatchResult: 'No matching results',
    processingBtn: 'Processing...',
    savingBtn: 'Saving...',
    updatingBtn: 'Updating...',
    creatingBtn: 'Creating...',
    submittingBtn: 'Submitting...',
    allStatuses: 'All Statuses',
    filterAll: 'All',
    confirmUpdate: 'Confirm Update',
    confirmAdd: 'Confirm Add',

    // === APP / DASHBOARD ===
    notifPanelTitle: 'Notifications',
    markAllReadBtn: 'Mark All as Read',
    noNotifications: 'No Notifications',
    systemSourceBadge: 'System Notification',
    systemShortLabel: 'System',
    dashboardTitle: 'Overview Dashboard',
    welcomeBackLabel: 'Welcome back,',
    dashProductTypes: 'Product Types',
    dashTotalStock: 'Total Stock',
    dashStockAlert: 'Stock Alert',
    dashTransactionRecords: 'Transaction Records',
    dashStockAlertBanner: 'Stock Alert — Products below safety stock',
    dashSystemModules: 'System Modules',
    moduleNotEnabled: 'Not Enabled',
    dashRecentTransactions: 'Recent Transactions',
    dashNoTransactions: 'No transaction records',
    realtimeSynced: 'Real-time Sync',
    connectingStatus: 'Connecting...',
    companyAdminRole: 'Company Admin',
    managerRole: 'Manager',
    generalUserRole: 'General User',
    needsUpgradeLocked: 'Requires Plan Upgrade',
    logoutBtn: 'Sign Out',
    featureModulesHeading: 'Feature Modules',
    fullBackupBtn: 'Full Backup',
    backupBtnDesc: 'Download all data locally',
    backupInProgress: 'Backup in progress...',
    backupComplete: 'Backup complete, downloaded locally',
    insufficientPermissions: 'Insufficient Permissions',
    noAccessMessage: 'Your account does not have permission to access this feature',
    backToOverviewBtn: 'Back to Overview',
    moduleNotActivated: 'This module is not activated for your company',
    contactSupportMsg: 'Contact YPFOPS customer service',
    unlockMoreMsg: 'Unlock more powerful features!',
    sendNotifyTitle: 'Send Notification',
    sendNotifySubtitle: 'Send real-time notifications to company users',
    notifyTargetLabel: 'Target',
    allEmployeesOption: 'All Employees',
    notifyTitleLabel: 'Notification Title *',
    notifyTitlePlaceholder: 'e.g.: Announcement, Reminder...',
    notifyBodyLabel: 'Notification Content *',
    notifyBodyPlaceholder: 'Enter notification details...',
    sendingNotifyBtn: 'Sending...',
    sendNowBtn: 'Send Now',
    logsPageTitle: 'Activity Logs',
    logSearchPlaceholder: 'Search by operator, action, or detail...',
    clearLogSearchBtn: 'Clear',
    reloadLogsBtn: 'Reload',
    noLogsMessage: 'No logs, or loading failed',
    noMatchingLogs: 'No matching logs',
    logColTime: 'Time',
    logColOperator: 'Operator',
    logColAction: 'Action',
    logColDetail: 'Detail',

    // === WMS ===
    warehouseTitle: '📦 Warehouse Management',
    wmsSubtitle: 'In/Out · Stock · Products · Ship · Pending In',
    wmsTabInOut: 'In/Out',
    wmsTabBatchIn: 'Batch Stock In',
    wmsTabLabels: 'Package Labels',
    wmsTabInventory: 'Inventory Status',
    wmsTabPendingShip: 'Pending Shipments',
    wmsTabPendingIn: 'Pending Stock In',
    wmsTabRecords: 'Records',
    wmsProductTypes: 'Product Types',
    wmsTotalStock: 'Total Stock',
    wmsPendingShip: 'Pending Shipment',
    wmsStockMovements: 'Stock Movements',
    wmsTransactionTitle: '🔄 Stock In/Out Registration',
    wmsProductField: 'Product *',
    wmsSearchProduct: 'Search product name...',
    wmsStockIn: '▲ Stock In',
    wmsStockOut: '▼ Stock Out',
    wmsStockInsufficient: '⛔ Insufficient Stock',
    wmsBelowSafeStock: '⚠️ Below safety stock, replenishment needed',
    wmsOutDate: 'Out Date',
    wmsNonTodayNote: '📅 Set to non-today date; shipment date will use this date',
    wmsCreateShip: '🚚 Also create shipment order',
    wmsAutoCreateShipDesc: 'Automatically add a pending shipment after stock out',
    wmsCustomerName: 'Customer Name *',
    wmsCustomerPh: 'Customer Name',
    wmsDriverLabel: 'Driver',
    wmsSelectDriver: '-- Select Driver --',
    wmsLicensePlate: 'License Plate',
    wmsConfirmStockIn: '▲ Confirm Stock In',
    wmsConfirmStockOut: '▼ Confirm Stock Out',
    wmsRecentRecords: 'Recent 10 Records',
    wmsBatchInTitle: '📦 Batch Stock In',
    wmsBatchInDesc: 'Stock in multiple products at once; for purchase arrivals or restocking',
    wmsAddProductRow: '+ Add Product',
    wmsConfirmBatchIn: '▲ Confirm Batch Stock In',
    wmsBatchPreview: 'Stock In Preview',
    wmsInventoryHeading: '📊 Current Inventory Status',
    wmsSearchNameSku: '🔍 Search product name / SKU',
    wmsAllCategories: 'All Categories',
    wmsLowStockWarning: '⚠️ Low Stock Alert',
    wmsNeedsReplenishment: '⚠ Needs Replenishment',
    wmsStockNormal: '✓ Normal',
    wmsInventoryCount: '📋 Count',
    wmsPendingShipHeading: '🚚 Pending Shipment List',
    wmsPrepareShipDesc: 'The following shipments are pending; please prepare goods',
    wmsGoToShipping: 'Go to Shipping Management →',
    wmsNoShipments: 'No pending shipment orders',
    wmsPendingInHeading: '📋 Pending Manual Stock-In Orders',
    wmsWaitingManualIn: 'Work orders done, awaiting manual stock-in',
    wmsNoPendingIn: 'No pending manual stock-in orders',
    wmsStockInProductLbl: 'Stock-In Product *',
    wmsConfirmStockInSmall: 'Confirm Stock In',
    wmsExecuteStockIn: 'Execute Stock In',
    wmsAutoStockInHeading: '⚡ Auto Stock-In Details',
    wmsAutoStockInDesc: 'Stock-in records triggered by production work orders',
    wmsNoAutoLogs: 'No auto stock-in records',
    wmsEditRecordTitle: '✏️ Edit Record',
    wmsEditReasonLabel: 'Edit Reason *',
    wmsCurrentStock: 'Current Stock:',
    wmsAdjustedQty: 'Adjusted Stock Quantity *',
    wmsStockDiff: 'Difference:',
    wmsCountReason: 'Count Reason *',
    wmsConfirmAdjust: 'Confirm Inventory Adjustment',
    wmsNoMatchRecords: 'No matching records',
    wmsLowStock: 'Low Stock',

    // === PRODUCTS ===
    productMgmtTitle: '📦 Product Management',
    productSubtitle: 'Product catalog, specs, stock, and pricing management',
    productTotal: 'Total Products',
    productActive: 'Active',
    productCategories: 'Product Categories',
    productStockValue: '📊 Total Stock Value (Cost)',
    productListTab: '📦 Product List',
    productAnalyticsTab: '📊 Analytics',
    productSearchPh: '🔍 Search name, SKU, barcode...',
    productActiveOpt: '✅ Active',
    productInactiveOpt: '⏸ Inactive',
    productLowStockOpt: '⚠️ Low Stock',
    productLowStockAlert: 'products below safety stock, need replenishment',
    productNameLabel: 'Product Name *',
    productSku: 'SKU *',
    productCategoryLabel: 'Category',
    productUnit: 'Unit',
    productInitialStock: 'Initial Stock',
    productSafeStock: 'Safety Stock',
    productCostPrice: 'Cost Price (NT$)',
    productSellPrice: 'Selling Price (NT$)',
    productBarcode: 'Barcode',
    productSpec: 'Specification',
    productSpecPh: 'Size, color, material...',
    productMinOrder: 'Min Order Qty',
    productWeight: 'Weight (kg)',
    productLeadTime: 'Lead Time (days)',
    productImageUrl: 'Image URL',
    productSelectCategory: '-- Select Category --',
    productAddCategory: '+ New',
    productNewCategoryHint: 'Enter new category name',
    productNamePh: 'Enter product name',
    productConfirmAdd: 'Confirm Add',
    productConfirmUpdate: 'Confirm Update',
    productQrLabels: '🏷️ QR Labels',
    productImportTitle: '📥 Batch Import Products',
    productDownloadTemplate: '⬇ Download Template',
    productSelectFile: '📂 Select File',
    productConfirmImport: 'Confirm Import',
    productCurrentStock: 'Current Stock',
    productGrossMargin: 'Gross Margin',
    productDeactivate: 'Deactivate',
    productActivate: 'Activate',
    productDetail: 'Details',
    productQuickAdjust: 'Quick Stock Adjustment',
    productStockInTitle: '▲ Quick Stock In',
    productStockOutTitle: '▼ Quick Stock Out',
    productDetailTitle: '📦 Product Details',
    productActiveStatus: '✅ Active',
    productInactiveStatus: '⏸ Inactive',
    productNewProduct: '+ Add Product',
    productNoData: 'No product data yet',

    // === TASKS ===
    taskPageTitle: '📋 Task Management',
    taskPageSubtitle: 'Assign · Track · Collaborate',
    taskTabMy: 'My Tasks',
    taskTabManage: 'Assign Management',
    taskTabAnalytics: 'Task Analytics',
    taskCatGeneral: 'General Task',
    taskCatSafety: 'Safety & Health',
    taskCatQuality: 'Quality Control',
    taskCatTraining: 'Training',
    taskCatMaintenance: 'Equipment Maintenance',
    taskCatImprovement: 'Improvement Proposal',
    taskPriUrgent: 'Urgent',
    taskPriHigh: 'High',
    taskPriNormal: 'Normal',
    taskPriLow: 'Low',
    taskStatusPending: 'Not Started',
    taskStatusInProgress: 'In Progress',
    taskStatusHelp: 'Help Needed',
    taskStatusCompleted: 'Completed',
    taskNameLabel: 'Task Name *',
    taskNamePh: 'Enter task name',
    taskDescLabel: 'Description (optional)',
    taskCategoryLabel: 'Category',
    taskPriorityLabel: 'Priority',
    taskDueDateLabel: 'Due Date (optional)',
    taskAssignLabel: 'Assign To *',
    taskSearchEmployee: '🔍 Search employee name',
    taskNoTasks: 'No tasks assigned to you',
    taskRelax: 'Take a break!',
    taskMyProgress: 'My Task Progress',
    taskGroupOverdue: '🔴 Overdue',
    taskGroupUrgent: '⚡ Urgent / Due Soon',
    taskGroupInProgress: '⚙️ In Progress',
    taskGroupNotStarted: '📋 Not Started',
    taskGroupDone: '✅ Completed',
    taskAllDone: 'All tasks completed!',
    taskBtnStart: '⚡ Start Task',
    taskBtnComplete: '✅ Complete Task',
    taskBtnConfirmComplete: '✅ Confirm Complete',
    taskBtnAskHelp: '🆘 Ask for Help',
    taskBtnResume: '⚡ Resume Task',
    taskBtnDetail: 'Details',
    taskBtnRemind: '🔔 Remind',
    taskBtnEdit: '✏️ Edit',
    taskBtnArchive: '📦 Archive',
    taskBtnRestore: '↩ Restore',
    taskBtnDelete: '🗑 Delete',
    taskNewTask: '+ New Task',
    taskFormNew: '📋 New Task',
    taskFormEdit: '✏️ Edit Task',
    taskConfirmCreate: 'Confirm Create',
    taskConfirmUpdate: 'Confirm Update',
    taskHelpTitle: '🆘 Request Help',
    taskHelpDesc: 'Describe what you need; your supervisor will contact you',
    taskHelpProblem: 'Describe Issue *',
    taskHelpPh: 'e.g. unsure how to operate machine, lack of materials...',
    taskSubmitHelp: '🆘 Submit Help Request',
    taskEmptyArchived: 'No archived tasks',
    taskEmptyNoTask: 'No tasks yet',

    // === CRM ===
    crmPageTitle: '👥 Customer Management',
    crmPageSubtitle: 'Customer Data · Contact Info · Shipment Records',
    crmTotalCustomers: 'Total Customers',
    crmHasPhone: 'Has Phone',
    crmHasEmail: 'Has Email',
    crmNewThisMonth: 'New This Month',
    crmSearchPh: '🔍 Search name, tax ID, contact, phone, email...',
    crmViewTable: '☰ Table',
    crmViewCard: '⊞ Cards',
    crmNewCustomer: '+ Add Customer',
    crmFormNewTitle: '👥 New Customer',
    crmCustName: 'Customer Name *',
    crmTaxId: 'Tax ID',
    crmContact: 'Contact Person',
    crmAddress: 'Address',
    crmNote: 'Notes',
    crmCustNamePh: 'Company or individual name',
    crmTaxIdPh: '8-digit tax ID',
    crmContactPh: 'Manager / contact window',
    crmAddressPh: 'City + full address',
    crmNotePh: 'Additional notes, special requirements...',
    crmConfirmAdd: 'Confirm Add',
    crmThName: 'Customer Name',
    crmThTaxId: 'Tax ID',
    crmThContact: 'Contact Person',
    crmThCreated: 'Created Date',
    crmThAction: 'Actions',
    crmNoCustomers: 'No customer records',
    crmNoMatch: 'No matching customers',
    crmEditTitle: '✏️ Edit Customer',
    crmConfirmUpdate: '✓ Confirm Update',
    crmProfileCompanyName: 'Company Name',
    crmProfileContact: 'Contact Person',
    crmProfilePhone: 'Phone',
    crmProfileAddress: 'Address',
    crmShipHistory: 'Shipment History',
    crmNoShipHistory: 'No shipment records',
    crmShipPending: 'Pending',
    crmShipConfirmed: 'Confirmed',
    crmShipShipped: 'Shipped',
    crmShipCancelled: 'Cancelled',

    // === PURCHASING ===
    purPageTitle: '🛒 Purchasing Management',
    purPageSubtitle: 'Supplier Mgmt · Purchase Request · Receiving',
    purTabPO: 'Purchase Orders',
    purTabSuppliers: 'Supplier Management',
    purTabAnalytics: 'Purchasing Analytics',
    purKpiSuppliers: 'Active Suppliers',
    purKpiTotalPO: 'Total POs',
    purKpiPending: 'Pending Review',
    purKpiOrdered: 'Ordered, Awaiting Receipt',
    purKpiReceived: 'Received This Month',
    purKpiOverdue: 'Overdue, Not Received',
    purStatusDraft: 'Draft',
    purStatusPending: 'Pending Review',
    purStatusApproved: 'Approved',
    purStatusOrdered: 'Ordered',
    purStatusReceived: 'Received',
    purStatusCancelled: 'Cancelled',
    purPoNoLabel: 'PO Number *',
    purPoNoPh: 'Auto-generated',
    purSupplierLabel: 'Supplier *',
    purSearchSupplier: 'Search supplier...',
    purRequester: 'Requester',
    purExpectedDate: 'Expected Arrival Date',
    purNoteLabel: 'Notes (optional)',
    purNotePh: 'Purchase reason, special requirements...',
    purItems: 'Purchase Items',
    purItemName: 'Item / Description',
    purItemNamePh: 'e.g. office chairs, computers, cleaning supplies...',
    purQty: 'Quantity',
    purUnit: 'Unit',
    purUnitPrice: 'Unit Price (NT$)',
    purAddItem: '+ Add Item',
    purTotalAmount: 'Total Amount: NT$',
    purNewPO: '+ New PO',
    purFormNew: '🛒 New Purchase Request',
    purFormEdit: '✏️ Edit PO',
    purConfirmCreate: 'Confirm Create PO',
    purSearchPO: '🔍 Search PO number, supplier...',
    purNoPO: 'No purchase orders yet',
    purBtnDetail: '🔍 Details',
    purBtnSubmit: '📤 Submit for Review',
    purBtnApprove: '✅ Approve',
    purBtnOrdered: '📦 Mark as Ordered',
    purBtnReceived: '🎉 Confirm Receipt',
    purBtnCancel: '✕ Cancel',
    purSupplierActive: 'Active',
    purSupplierInactive: 'Inactive',
    purNewSupplier: '+ New Supplier',
    purFormNewSupplier: '🏭 New Supplier',
    purFormEditSupplier: '✏️ Edit Supplier',
    purSupplierName: 'Supplier Name *',
    purSupplierCode: 'Supplier Code',
    purPaymentTerms: 'Payment Terms',
    purSupplierAddress: 'Address',
    purNoSuppliers: 'No suppliers yet',
    purDetailTitle: '📋 PO Details',
    purCancelTitle: 'Cancel PO',
    purCancelReason: 'Cancellation Reason (optional)',
    purConfirmCancel: 'Confirm Cancel This PO',

    // === PRODUCTION ===
    prodPageTitle: '🏭 Production Management',
    prodSubtitle: 'Work Order Tracking',
    prodTabWorkOrders: '📋 Work Order Management',
    prodTabMachines: '⚙️ Machine Management',
    prodNewOrder: '+ New Work Order',
    prodStageSettings: '⚙️ Stage Settings',
    prodSearchOrders: '🔍 Search order no., product name...',
    prodFilterOverdue: '⚠️ Overdue',
    prodNoMatch: 'No matching orders',
    prodNoOrders: 'No Work Orders',
    prodOrderNo: 'Order No. *',
    prodLinkedProduct: 'Linked Product (optional)',
    prodSearchProduct: 'Search products...',
    prodOrderName: 'Product / Order Name *',
    prodBatchQty: 'Batch Quantity *',
    prodStartDate: 'Start Date',
    prodDueDate: 'Due Date',
    prodMachine: 'Assigned Machine',
    prodSearchMachine: 'Search machine code/name...',
    prodDepartment: 'Department',
    prodDepartmentPh: 'e.g. Line A, Stamping Dept...',
    prodNoteLabel: 'Note',
    prodConfirmCreate: 'Confirm Create Order',
    prodStatusPending: 'Pending',
    prodStatusInProd: 'In Production',
    prodStatusDone: 'Done',
    prodBadgeOverdue: '⚠️ Overdue',
    prodBadgeQcPassed: '✅ QC Passed',
    prodBadgeQcFailed: '❌ QC Failed',
    prodBtnStart: '🚀 Start',
    prodBtnAdvance: '▶ Advance to',
    prodBtnEdit: '✏️ Edit',
    prodBtnHistory: '📋 History',
    prodBtnWarehouse: '📦 Go to Stock-In',
    prodBtnDelete: 'Delete',
    prodReportProgress: '📝 Report Progress',
    prodMoveToLabel: 'Move To',
    prodCompletionInfo: '✅ Completion Info',
    prodActualQty: 'Actual Completed Qty *',
    prodStockMode: 'Stock-In Method',
    prodAutoStock: '⚡ Auto Stock-In',
    prodManualStock: '📋 Manual Stock-In',
    prodReporter: 'Reporter',
    prodQcRecord: '🔍 QC Record (optional)',
    prodQcName: 'QC Inspector',
    prodQcResult: 'QC Result',
    prodQcPass: '✅ Pass',
    prodQcFail: '❌ Fail',
    prodQcPending: '— Not Reviewed',
    prodQcNote: 'QC Notes',
    prodConfirmAdvance: 'Confirm Advance to:',
    prodHistoryTitle: '📋 Production History',
    prodNoHistory: 'No progress records yet',
    prodEditTitle: '✏️ Edit Work Order',
    prodSaveChanges: '✓ Save Changes',
    prodStageSettingsTitle: '⚙️ Production Stage Settings',
    prodAddStage: 'Add',
    prodSaveSettings: '✓ Save Settings',
    prodResetDefault: 'Reset to Default',
    prodMachineCountInfo: 'Shared with Maintenance module',
    prodAddMachine: '+ Add Machine',
    prodAddMachineTitle: '⚙️ Add Machine',
    prodNoMachines: 'No machines yet',
    prodMachineStatusNormal: 'Normal',
    prodMachineStatusMaint: 'Under Maintenance',
    prodMachineStatusInactive: 'Inactive',
    prodMachineName: 'Machine Name *',
    prodMachineCode: 'Machine Code *',
    prodMachineDiv: 'Department',
    prodMachineLocation: 'Location',
    prodMachineResponsible: 'Responsible Person',
    prodMachineSupplier: 'Supplier',
    prodMachineStatusLabel: 'Status',
    prodEditMachineTitle: '✏️ Edit Machine',

    // === SHIPPING ===
    shipPageTitle: '🚚 Shipping Management',
    shipSubtitle: 'Shipments & Driver/Plate Management',
    shipTabShipments: '📋 Shipments',
    shipTabRecords: '🔍 Record Search',
    shipTabDrivers: '🚛 Driver / Plate Management',
    shipStatTotal: 'Total Shipments',
    shipStatPending: 'Pending',
    shipStatShipped: 'Shipped',
    shipStatDrivers: 'Available Drivers',
    shipStatusPending: 'Pending',
    shipStatusShipped: 'Shipped',
    shipStatusCancelled: 'Cancelled',
    shipNewShipment: '+ New Shipment',
    shipSearchPh: '🔍 Search customer / shipment no.',
    shipNoLabel: 'Shipment No. *',
    shipCustomerLabel: 'Customer *',
    shipSearchCustomer: 'Search customer name...',
    shipDateLabel: 'Shipment Date',
    shipDriverSection: '🚛 Driver / Plate Info',
    shipSelectDriver: 'Select Driver',
    shipDriverNameLabel: 'Driver Name',
    shipLicensePlate: 'License Plate',
    shipItemsSection: 'Shipment Items',
    shipProductLabel: 'Product',
    shipQtyLabel: 'Qty',
    shipFormTitle: '🚚 New Shipment',
    shipConfirmCreate: 'Confirm Create Shipment',
    shipThNo: 'Shipment No.',
    shipThCustomer: 'Customer',
    shipThDriver: 'Driver',
    shipThPlate: 'Plate',
    shipThItems: 'Items',
    shipThDate: 'Ship Date',
    shipThStatus: 'Status',
    shipThAction: 'Action',
    shipNoShipments: 'No shipments yet',
    shipBtnDetail: 'Details',
    shipBtnConfirmShip: 'Confirm Shipment',
    shipBtnCancel: 'Cancel',
    shipAddDriver: '+ Add Driver',
    shipAddDriverTitle: '🚛 New Driver',
    shipNoDrivers: 'No drivers yet',
    shipDriverStatus: 'Status',
    shipDriverEmployed: '✅ Employed',
    shipDriverResigned: '⏸ Resigned',
    shipConfirmAddDriver: 'Confirm Add',
    shipEditDriverTitle: '✏️ Edit Driver',
    shipDetailTitle: '📋 Shipment Details',
    shipNoRecords: 'No matching records',

    // === MAINTENANCE ===
    mntPageTitle: '🔧 Machine Maintenance',
    mntSubtitle: 'Breakdown · Maintenance · Parts · Machine Mgmt',
    mntTabRecords: '🔧 Maintenance Records',
    mntTabMachines: '⚙️ Machine Management',
    mntTypeBreakdown: 'Breakdown Repair',
    mntTypePreventive: 'Preventive Maintenance',
    mntTypeScheduled: 'Scheduled Maintenance',
    mntTypeInspection: 'Routine Inspection',
    mntTypeParts: 'Parts Replacement',
    mntStatusPending: 'Pending',
    mntStatusInProgress: 'In Progress',
    mntStatusWaitParts: 'Waiting for Parts',
    mntStatusCompleted: 'Completed',
    mntKpiStopped: 'Machine Down',
    mntKpiWaitParts: 'Waiting Parts',
    mntKpiTotal: 'Total Machines',
    mntFilterActive: '⚡ Active',
    mntFilterAll: 'All',
    mntFilterWaitParts: '📦 Waiting Parts',
    mntFilterCompleted: '✅ Completed',
    mntNewReport: '+ New Report',
    mntSearchPh: '🔍 Search machine, reporter, description...',
    mntNoMatch: 'No matching maintenance records',
    mntNoActive: 'No pending maintenance tasks ✅',
    mntNoRecords: 'No maintenance records yet',
    mntReportTitle: '🔧 New Maintenance Report',
    mntSelectMachine: 'Select Machine *',
    mntSearchMachine: 'Enter machine code or name to search...',
    mntReportType: 'Report Type *',
    mntMachineDown: '🔴 Machine is Down',
    mntProblemDesc: 'Problem Description *',
    mntProblemPh: 'Describe the fault or abnormality in detail...',
    mntReporterName: 'Reporter *',
    mntSubmitReport: '📤 Submit Report',
    mntAssignTitle: '⚙️ Assign Maintenance',
    mntAssignee: 'Assigned Technician *',
    mntEstDone: 'Estimated Completion Date',
    mntConfirmAssign: '▶ Confirm Assign & Start',
    mntWaitPartsTitle: '📦 Waiting for Parts',
    mntNeededParts: 'What parts / supplies are needed?',
    mntNeededPartsPh: 'e.g. Bearing × 2, Oil Seal × 1, Belt × 3...',
    mntConfirmWaitParts: '📦 Confirm, Waiting for Parts',
    mntCompleteTitle: '✅ Report Completion',
    mntSolution: 'Repair Method / Solution *',
    mntSolutionPh: 'Describe how the fault was resolved...',
    mntPartsUsed: '🔩 Parts Used / Replaced',
    mntRepairCost: 'Repair Cost NT$',
    mntConfirmComplete: '✅ Confirm Complete',
    mntDetailTitle: '🔧 Maintenance Details',
    mntMachineCode: 'Machine Code',
    mntReportDate: 'Report Date',
    mntNoMachines: 'No machines yet, click top-right to add',
    mntBtnAssign: '⚙️ Assign & Start',
    mntBtnWaitParts: '📦 Wait for Parts',
    mntBtnComplete: '✅ Report Complete',
    mntBtnDetail: '👁 Details',
    mntBtnModify: '✏️ Modify',

    // === FIVES ===
    fivesPageTitle: '5S Management System',
    fivesSubtitle: 'Sort · Set in Order · Shine · Standardize · Sustain',
    fivesTabMyScore: 'My Score',
    fivesTabHistory: 'History',
    fivesTabManage: 'Manage Forms',
    fivesTabAnalytics: 'Analytics',
    fivesScoreUnacceptable: 'Unacceptable',
    fivesScorePoor: 'Poor',
    fivesScoreAverage: 'Average',
    fivesScoreGood: 'Good',
    fivesScoreExcellent: 'Excellent',
    fivesDimSeiri: 'Sort',
    fivesDimSeiton: 'Set in Order',
    fivesDimSeiso: 'Shine',
    fivesDimSeiketsu: 'Standardize',
    fivesDimShitsuke: 'Sustain',
    fivesNoFormThisWeek: 'No 5S form assigned to you this week',
    fivesContactAdmin: 'Please contact the administrator to create and assign a form',
    fivesViewHistory: 'View History',
    fivesAlreadySubmitted: 'Submitted',
    fivesLowScoreAlert: 'Low-score items need attention',
    fivesNotScored: 'Not Rated',
    fivesSubmitWeekly: 'Submit Weekly 5S Score',
    fivesUpdateScore: 'Update Score',
    fivesNoHistory: 'You have no 5S history records',
    fivesCreateForm: 'Create New Form',
    fivesCopyLast: "Copy Last Week's Form",
    fivesExportAll: 'Export All Records',
    fivesFormTitle: 'Form Title *',
    fivesWeekStart: 'Week Start Date *',
    fivesAssignUsers: 'Assign Users *',
    fivesNoForms: 'No 5S Forms Yet',
    fivesFormActive: 'Active',
    fivesFormInactive: 'Inactive',
    fivesDeactivate: 'Deactivate',
    fivesActivate: 'Activate',
    fivesDelete: 'Delete',
    fivesDetailTitle: 'Details',
    fivesNoDataAnalytics: 'Insufficient data for analytics',
    fivesThisWeekAvg: "This Week's Average Score",
    fivesThisWeekRate: "This Week's Submission Rate",
    fivesTopEmployee: 'Top Employee',
    fivesNeedsImprovement: 'Item Most Needing Improvement',
    fivesWeeklyTrend: 'Weekly Average Score Trend',
    fivesMonthlySubmit: 'Monthly Submission Count',
    fivesDimAvg: 'Average Score by Dimension',
    fivesEmployeeRanking: 'Employee Score Ranking',

    // === ATTENDANCE ===
    attPageTitle: 'Attendance Management',
    attSubtitle: 'Clock-in, Calendar, Leave, Work Hours',
    attTabMyClock: 'My Clock',
    attTabCalendar: 'Calendar',
    attTabLeave: 'Leave Application',
    attTabManage: 'Manage Attendance',
    attTabAnalytics: 'Analytics',
    attStatusNormal: 'Normal',
    attStatusLate: 'Late',
    attStatusEarlyLeave: 'Early Leave',
    attStatusAbsent: 'Absent',
    attStatusLeave: 'Leave',
    attLeaveAnnual: 'Annual Leave',
    attLeaveSick: 'Sick Leave',
    attLeavePersonal: 'Personal Leave',
    attLeaveOfficial: 'Official Leave',
    attLeaveOther: 'Other',
    attLeaveStatusPending: 'Pending Review',
    attLeaveStatusApproved: 'Approved',
    attLeaveStatusRejected: 'Rejected',
    attClockInTime: 'Clock-In Time',
    attClockOutTime: 'Clock-Out Time',
    attWorkHours: 'Work Hours',
    attNotClockedIn: 'Not clocked in today',
    attClockInBtn: 'Clock In',
    attClockOutBtn: 'Clock Out',
    attMonthlyAttendance: 'Monthly Attendance',
    attMonthlyHours: 'Monthly Work Hours',
    attMonthlyLate: 'Monthly Late Count',
    attMonthlyOvertime: 'Monthly Overtime',
    attNoClockRecords: 'No clock records yet',
    attCalPrevMonth: 'Previous Month',
    attCalNextMonth: 'Next Month',
    attReturnThisMonth: 'Return to This Month',
    attLeaveType: 'Leave Type',
    attStartDate: 'Start Date *',
    attEndDate: 'End Date *',
    attLeaveReason: 'Leave Reason *',
    attLeaveReasonPh: 'Please enter the reason for leave...',
    attSubmitLeave: 'Submit Leave Application',
    attMyApplications: 'My Applications',
    attAllApplications: 'All Applications (Management)',
    attApprove: 'Approve',
    attReject: 'Reject',
    attNoLeaveRecords: 'No leave records',
    attTodayClockedIn: 'Clocked In Today',
    attTodayLate: 'Late Today',
    attTodayNotClockedIn: 'Not Clocked In Today',
    attExportCsv: 'Export CSV',
    attSettings: 'Settings',
    attManualClock: 'Manual Clock Entry',
    attThDate: 'Date',
    attThEmployee: 'Employee',
    attThClockIn: 'Clock In',
    attThClockOut: 'Clock Out',
    attThHours: 'Work Hours',
    attThStatus: 'Status',
    attNoRecords: 'No attendance records',
    attWorkStart: 'Work Start Time',
    attWorkEnd: 'Work End Time',
    attLateThreshold: 'Late Threshold (minutes)',
    attRequireGps: 'Require GPS Verification',
    attConfirmSave: 'Confirm Save',
    attAnalyticsTotal: 'Total Monthly Attendance Records',
    attAnalyticsLate: 'Monthly Late Count',
    attAnalyticsHours: 'Total Monthly Work Hours',
    attAnalyticsOvertime: 'Total Monthly Overtime',
    attTrend6Months: 'Attendance Trend – Last 6 Months',
    attPersonalStats: 'Personal Monthly Attendance Stats',
    attNoDataThisMonth: 'No Data This Month',
    attLateRanking: 'Monthly Late Ranking',
    attExportReport: 'Export Report',

    // === REPORTS ===
    rptPageTitle: 'Reports & Analytics',
    rptSubtitle: 'Inbound/Outbound · Shipping · Purchasing · Production · Inventory · Maintenance',
    rptTabOverview: 'Overview',
    rptTabInOut: 'Inbound/Outbound Trend',
    rptTabShipping: 'Shipping Analysis',
    rptTabPurchasing: 'Purchasing Analysis',
    rptTabProduction: 'Production Efficiency',
    rptTabInventory: 'Inventory Analysis',
    rptTabMaintenance: 'Maintenance Report',
    rptKpiProductTypes: 'Product Types',
    rptKpiNeedsRestock: 'Needs Restocking',
    rptKpiSufficient: 'Stock Sufficient',
    rptKpiInbound: 'This Month Inbound',
    rptKpiOutbound: 'This Month Outbound',
    rptKpiShipments: 'This Month Shipments',
    rptKpiWorkOrderRate: 'Work Order Completion Rate',
    rptNoData: 'No Data Yet',
    rptLast7DaysTitle: 'Last 7 Days Inbound/Outbound',
    rptLegendInbound: 'Inbound',
    rptLegendOutbound: 'Outbound',
    rptRestockAlertTitle: 'Restock Alert',
    rptAllSufficient: 'All products have sufficient stock',
    rptWorkOrderStatus: 'Work Order Status',
    rptShippingTitle: 'Shipment Orders – Last 6 Months',
    rptPurchasingTitle: 'Purchase Orders – Last 6 Months',
    rptProductionTitle: 'Work Order Completion Rate',
    rptInventoryByCategory: 'Inventory by Category',
    rptRestockList: 'Restock Alert List',
    rptExportRestock: 'Export Restock Order',
    rptInventoryTurnover: 'Inventory Turnover Rate TOP 10',
    rptExportInventory: 'Export Full Inventory CSV',
    rptMaintTotal: 'Total Maintenance Records',
    rptMaintProcessing: 'Processing',
    rptMaintStopped: 'Stopped',
    rptMaintCost: 'Total Repair Cost',
    rptMonthlyRepair: 'Monthly Repair Count',
    rptRepairTypeDist: 'Repair Type Distribution',
    rptMachineFailRanking: 'Machine Failure Ranking',
    rptRecentCompleted: 'Recent Completed Records',
    rptExportAll: 'Export All',
    rptNoCompletedRepairs: 'No Completed Repair Records',
  },

  vi: {
    // Navigation — Vietnamese translated
    navDashboard: 'Tổng quan',
    navMore: 'Thêm',
    navPositions: 'Chức vụ',
    navUsers: 'Nhân viên',
    navNotify: 'Thông báo',
    navLogs: 'Nhật ký',
    navRegister: 'Tạo tài khoản',
    locked: 'Chưa kích hoạt',
    lockedMsg: 'Công ty chưa kích hoạt mô-đun này',
    lockedContact: 'Liên hệ YPFOPS để mở khóa',
    backToHome: '← Về trang chính',
    logout: 'Đăng xuất',
    settings: 'Cài đặt',
    profile: 'Hồ sơ',
    password: 'Đổi mật khẩu',
    appearance: 'Giao diện',
    dashboard: 'Bảng điều khiển',
    themeLabel: 'Chủ đề hiển thị',
    light: 'Chế độ sáng',
    dark: 'Chế độ tối',
    languageLabel: 'Ngôn ngữ',
    langZh: '繁體中文',
    langEn: 'English',
    langVi: 'Tiếng Việt',
    employeeId: 'Mã nhân viên',
    department: 'Phòng ban',
    position: 'Chức vụ',
    loginAccount: 'Email đăng nhập',
    adminNote: 'Thông tin trên do quản trị viên quản lý. Vui lòng liên hệ quản trị viên để thay đổi.',
    displayName: 'Tên hiển thị',
    namePlaceholder: 'Nhập tên của bạn',
    phone: 'Điện thoại',
    phonePlaceholder: 'VD: 0912-345-678',
    saveProfile: '✓ Lưu hồ sơ',
    saving: 'Đang lưu...',
    pwdReminder: 'Sau khi đổi mật khẩu, dùng mật khẩu mới để đăng nhập. Nên kết hợp chữ và số, ít nhất 8 ký tự.',
    newPassword: 'Mật khẩu mới',
    newPasswordPlaceholder: 'Ít nhất 6 ký tự',
    confirmPassword: 'Xác nhận mật khẩu mới',
    confirmPasswordPlaceholder: 'Nhập lại mật khẩu mới',
    pwdMismatch: '⚠ Mật khẩu không khớp',
    pwdCheck8: '✓ Trên 8 ký tự',
    pwdCheckFail8: '✗ Dưới 8 ký tự',
    pwdCheckMixed: '✓ Chữ và số',
    pwdCheckFailMixed: '✗ Nên kết hợp',
    changePassword: '🔐 Cập nhật mật khẩu',
    changingPassword: 'Đang cập nhật...',
    profileSaved: '✓ Hồ sơ đã cập nhật',
    pwdSaved: '✓ Mật khẩu đã cập nhật. Dùng mật khẩu mới lần đăng nhập tiếp theo.',
    fieldRequired: 'Tên không được để trống',
    pwdRequired: 'Vui lòng nhập mật khẩu mới',
    pwdTooShort: 'Mật khẩu ít nhất 6 ký tự',
    // All other vi keys fall back to English via t() function
  },
}

export function t(lang, key) {
  if (lang === 'vi') return T['vi']?.[key] ?? T['en']?.[key] ?? T['zh-TW']?.[key] ?? key
  return T[lang]?.[key] ?? T['zh-TW']?.[key] ?? key
}

export function makeT(lang) { return key => t(lang, key) }
